import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { DataObjectUrl } from './DataObjectUrl';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { ISODate } from '../../common/utils';

export interface ValidateRequiredKeysResponse {
  errors: KeyValidationError[];
  excel?: ValidationErrorsExcel | null;
}

export interface KeyValidationError {
  error: string;
  sequenceNumber: string;
  sourceKey: string;
  dimension: string;
  component: string;
  valueDate: string;
  id: string;
  args?: Record<string, unknown> | null;
}

export interface ValidationErrorsExcel {
  fileName: string;
  contentType: string;
  base64: string;
}

export const getValidationErrors = async ({
  id,
  valueDate,
}: {
  id: string | number;
  valueDate: ISODate | null;
}) => {
  const res = await apiClient.get<ValidateRequiredKeysResponse>(
    expand(DataObjectUrl.VALIDATE_REQUIRED_KEYS, { id, valueDate }),
  );
  return res.data;
};

export const useValidateRequiredKeys = createApiQueryHook(
  ['data-object-description-validate-required-keys'],
  getValidationErrors,
);
